angular.module('admin.subscribers.index', [
  'security.authorization',
  'services.utility',
  'resources.AdminGroup',
  'resources.AdminUser',
  'services.adminResource',
  'services.search',
  'filters.timeAgo',
  'services.algoliaResource',
  'directives.croppic',
  'services.localizedMessages'
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin.subscribers', {
      url: '/subscribers',
      title: 'Manage Subscribers',
      views: {
        'main@': {
          template: require('./admin-subscribers.tpl.html'),
          controller: 'SubscribersIndexCtrl',
          resolve: {
            groups: ["AdminGroup", function (AdminGroup) {
              return AdminGroup.query().$promise;
            }]
          }
        }
      },
      resolve: {
        initSearch: ["searchService", "AdminUser", function (searchService, AdminUser) {
          searchService.setSearchFn(AdminUser.search);
          searchService.setRedirectBase('/admin/subscribers/edit');
        }]
      }
    });
}])

.controller('SubscribersIndexCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "AdminUser", "algoliaResource", "searchService", "groups", "localizedMessages", function($scope, $route, $location, $log, utility, adminResource, AdminUser, algoliaResource, searchService, groups, localizedMessages) {
    $scope.localizedMessages = localizedMessages;
    $scope.search = searchService.search;
    $scope.groups = groups.data;

    $scope.getAuthor = function ($item) {
            $scope.author = $item.name + ' performance';
            $scope.query.author = $item.username;
        };
    // local var
    var deserializeData = function(data){
      $scope.page = data.meta.page;
      $scope.query = data.meta.query;
      $scope.users = data.data;
      console.log(data)
    };


    var fetchData = function () {
      adminResource.findSubscribers($scope.query).then(function(data) {
        deserializeData(data);
        //update url in browser addr bar
        $location.search($scope.query);
      }, function(e) {
        $log.error(e);
      });
    };

    $scope.$watchCollection('query', function(newState, oldState) {
      if ( angular.equals(newState, oldState) ) {
        return;
      }
      fetchData();
    });

    //select elements and their associating options
    /*if (query.groups) {
      query.groups = _.map(query.groups, '_id');
    }
    $scope.groups = [
      {label: "Editor ESPAÑA", value: "57d72a2d9dd8590130bf71ed"},
      {label: "Writer Spain", value: "57d72a2d9dd8590130bf71f2"},
      {label: "Editor ITALIA", value: "57d72a2d9dd8590130bf71f4"}
    ];*/
    $scope.roles = [{label: "any", value: ""}, {label: "admin", value: "admin"}, {label: "account", value: "account"}];
    $scope.isActives =[{label: "either", value: ""}, {label: "yes", value: "yes"}, {label: "no", value: "no"}];
    $scope.sorts = [
      {label: "id \u25B2", value: "_uid"},
      {label: "id \u25BC", value: "-_uid"},
      {label: "username \u25B2", value: "username"},
      {label: "username \u25BC", value: "-username"},
      {label: "email \u25B2", value: "email"},
      {label: "email \u25BC", value: "-email"}
    ];
    $scope.limits = [
      {label: "10 Materiałów", value: 10},
      {label: "20 Materiałów", value: 20},
      {label: "50 Materiałów", value: 50},
      {label: "100 Materiałów", value: 100}
    ];

    $scope.query = $location.search();
    $scope.query.limit = $scope.query.limit || 10;
    $scope.query.is_active = '';
    $scope.query.group = '';
    $scope.query.author = '';

    fetchData();

    $scope.algoliaReindexing = function() {
      algoliaResource.indexingAuthors().then((result) =>{
          $scope.algoliaSuccess = true;
      }).catch((error) => {
          $scope.algoliaError = true;
      })
    }
  }]);

  


// WEBPACK FOOTER //
// ./client/src/app/admin/subscribers/admin-subscribers.js